export default __webpack_public_path__ + "static/left-chatgenie-8347685049efa9650e7e1d0cb4a697fe.svg";